var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import * as ServiceDashboard from '../../services/dashboard';
import { formatDateTime, formatNumber } from '../../services/utils/utils';
import { CircularProgressBar } from './CircularProgressBar';
import { Link } from '../../utils/Link';
import { useState, useEffect, useCallback } from 'react';
import { Chip, Stack } from '@mui/material';
import { renderInfo, Table } from '../../utils/Table';
import { AffaireIcon, CollaborateurIcon, ClientIcon, ActiviteIcon, MargeIcon, EuroIcon, CreationPortefeuilleIcon, PortfefeuilleIcon, SignatureIcon, InfoIcon, } from '../../utils/Icons';
import { EditionActivite } from '../activite/EditionActivite';
import { Spinner } from '../../utils/Spinner';
import { FONT_SIZE } from '../../theme';
import { getColor, getColors } from '../../utils/Classes';
import { getIsMobile } from '../../services/utilisateur';
import { Typography } from '../../utils/Typography';
export var TYPE_STATISTIQUE = {
    Forecast: 'Forecast',
    Recapitulatif: 'Recapitulatif',
    Portefeuille: 'Portefeuille',
    HitRatio: 'HitRatio',
    TotauxByTypeCatalogue: 'TotauxByTypeCatalogue',
    TotauxByCatalogue: 'TotauxByCatalogue',
    MixProduit: 'MixProduit',
    TopClient: 'TopClient',
    TopAffaireEnCours: 'TopAffaireEnCours',
    TopAffaireGagnee: 'TopAffaireGagnee',
    Compteurs: 'Compteurs',
    DerniersClients: 'DerniersClients',
    Activites: 'Activites',
    ProchainesActivites: 'ProchainesActivites',
    Synthese: 'Synthese',
};
export var Statistique = function (props) {
    var palette = getColors();
    var isMobile = getIsMobile();
    var Display = props.Display, Debut = props.Debut, Fin = props.Fin, _a = props.GroupeId, GroupeId = _a === void 0 ? null : _a, _b = props.CollaborateurIds, CollaborateurIds = _b === void 0 ? null : _b, _c = props.TagId, TagId = _c === void 0 ? null : _c;
    var _d = useState(true), loading = _d[0], setLoading = _d[1];
    var _e = useState(null), datas = _e[0], setDatas = _e[1];
    var getData = useCallback(function (useLoader) {
        if (useLoader === void 0) { useLoader = true; }
        return __awaiter(void 0, void 0, void 0, function () {
            var functionGetdatas, data;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (useLoader) {
                            setLoading(true);
                        }
                        functionGetdatas = null;
                        switch (Display) {
                            case TYPE_STATISTIQUE.Forecast:
                                functionGetdatas = ServiceDashboard.getForecast;
                                break;
                            case TYPE_STATISTIQUE.Recapitulatif:
                                functionGetdatas = ServiceDashboard.getRecapitulatif;
                                break;
                            case TYPE_STATISTIQUE.Portefeuille:
                                functionGetdatas = ServiceDashboard.getPortefeuilleDetails;
                                break;
                            case TYPE_STATISTIQUE.HitRatio:
                                functionGetdatas = ServiceDashboard.getHitRatio;
                                break;
                            case TYPE_STATISTIQUE.TotauxByTypeCatalogue:
                                functionGetdatas = ServiceDashboard.getTotauxByTypeCatalogue;
                                break;
                            case TYPE_STATISTIQUE.TotauxByCatalogue:
                                functionGetdatas = ServiceDashboard.getTotauxByCatalogue;
                                break;
                            case TYPE_STATISTIQUE.MixProduit:
                                functionGetdatas = ServiceDashboard.getMixProduit;
                                break;
                            case TYPE_STATISTIQUE.TopClient:
                                functionGetdatas = ServiceDashboard.getTopClient;
                                break;
                            case TYPE_STATISTIQUE.TopAffaireEnCours:
                                functionGetdatas = ServiceDashboard.getTopAffaireEnCours;
                                break;
                            case TYPE_STATISTIQUE.TopAffaireGagnee:
                                functionGetdatas = ServiceDashboard.getTopAffaireGagnee;
                                break;
                            case TYPE_STATISTIQUE.Compteurs:
                                functionGetdatas = ServiceDashboard.getTotaux;
                                break;
                            case TYPE_STATISTIQUE.DerniersClients:
                                functionGetdatas = ServiceDashboard.getDerniersClients;
                                break;
                            case TYPE_STATISTIQUE.Activites:
                                functionGetdatas = ServiceDashboard.getActivites;
                                break;
                            case TYPE_STATISTIQUE.ProchainesActivites:
                                functionGetdatas = ServiceDashboard.getProchainesActivites;
                                break;
                            case TYPE_STATISTIQUE.Synthese:
                                functionGetdatas = ServiceDashboard.getSynthese;
                                break;
                            default:
                                throw new Error("Statistique non g\u00E9r\u00E9 (".concat(Display));
                        }
                        return [4 /*yield*/, functionGetdatas({
                                DateDebut: Debut,
                                DateFin: Fin,
                                GroupeId: GroupeId,
                                CollaborateurIds: CollaborateurIds,
                                TagId: TagId,
                            })];
                    case 1:
                        data = _a.sent();
                        setDatas(data);
                        setLoading(false);
                        return [2 /*return*/];
                }
            });
        });
    }, [Display, Debut, Fin, GroupeId, CollaborateurIds, TagId]);
    useEffect(function () {
        getData();
    }, [Display, Debut, Fin, GroupeId, CollaborateurIds, TagId]);
    var renderForecast = function () {
        return (_jsx(Stack, __assign({ direction: "row", justifyContent: "end" }, { children: _jsxs(Stack, __assign({ direction: "row", sx: {
                    width: 'min-content',
                    backgroundColor: 'transparent',
                    border: '4px solid ' + getColor(palette),
                    color: getColor(palette),
                    fontWeight: 'bold',
                    borderRadius: 25,
                } }, { children: [_jsx(Chip, { label: _jsx(Typography, __assign({ startIcon: _jsx(SignatureIcon, {}) }, { children: "Estimation" })), style: {
                            marginLeft: -2,
                            backgroundColor: getColor(palette),
                            color: getColor(palette, 'white'),
                        } }), loading ? (_jsx(Spinner, { sx: { minWidth: 80, marginLeft: 1, marginRight: 1 } })) : datas ? (_jsx(Chip, { style: {
                            backgroundColor: getColor(palette, 'white'),
                            color: getColor(palette),
                        }, label: formatNumber(datas.Forecast, '€') })) : (_jsx(_Fragment, {}))] })) })));
    };
    var renderTopClient = function () {
        if (loading) {
            return _jsx(Spinner, {});
        }
        var TopClient = Array.isArray(datas) ? datas : [];
        return (_jsx(Table, { datas: TopClient, color: "client", headers: __spreadArray([
                {
                    label: (_jsx(Typography, __assign({ startIcon: _jsx(SignatureIcon, {}) }, { children: "Top 10 clients" }))),
                    component: function (value) { return (_jsx(Link, { title: value.Libelle, color: "client", to: '/client/fiche/' + value.IdClient, icon: _jsx(ClientIcon, {}) })); },
                },
                {
                    align: 'right',
                    label: 'Nb. affaires',
                    component: function (value) { return formatNumber(value.Quantite, ''); },
                },
                {
                    align: 'right',
                    label: 'Tarif',
                    component: function (value) { return formatNumber(value.TotalTarif, '€'); },
                }
            ], (isMobile
                ? []
                : [
                    {
                        align: 'right',
                        label: '% de mes tarifs',
                        component: function (value) {
                            return formatNumber(value.RatioTotalTarif * 100, '%');
                        },
                    },
                    {
                        align: 'right',
                        label: 'Marge',
                        component: function (value) { return formatNumber(value.TotalMarge, '€'); },
                    },
                    {
                        align: 'right',
                        label: '% de mes marges',
                        component: function (value) {
                            return formatNumber(value.RatioTotalMarge * 100, '%');
                        },
                    },
                ]), true) }));
    };
    var renderTopAffaireEnCours = function () {
        if (loading) {
            return _jsx(Spinner, {});
        }
        var TopAffaireEnCours = datas ? datas : [];
        return (_jsx(Table, { color: "secondary", datas: TopAffaireEnCours, headers: [
                {
                    label: (_jsx(Typography, __assign({ startIcon: _jsx(SignatureIcon, {}) }, { children: "Top 10 affaires en cours" }))),
                    component: function (value) { return (_jsx(Link, { title: value.Libelle, color: "affaire", to: '/affaire/fiche/' + value.IdAffaire, icon: _jsx(AffaireIcon, {}) })); },
                },
                {
                    align: 'right',
                    label: 'Tarif',
                    component: function (value) { return formatNumber(value.TotalTarif, '€'); },
                },
                {
                    align: 'right',
                    label: 'Marge',
                    component: function (value) { return formatNumber(value.TotalMarge, '€'); },
                },
            ] }));
    };
    var renderTopAffaireGagnee = function () {
        if (loading) {
            return _jsx(Spinner, {});
        }
        var TopAffaireGagnee = datas ? datas : [];
        return (_jsx(Table, { color: "affaire", datas: TopAffaireGagnee, headers: [
                {
                    label: (_jsx(Typography, __assign({ startIcon: _jsx(SignatureIcon, {}) }, { children: "Top 10 affaires valid\u00E9es" }))),
                    component: function (value) { return (_jsx(Link, { title: value.Libelle, color: "affaire", to: '/affaire/fiche/' + value.IdAffaire, icon: _jsx(AffaireIcon, {}) })); },
                },
                {
                    align: 'right',
                    label: 'Tarif',
                    component: function (value) { return formatNumber(value.TotalTarif, '€'); },
                },
                {
                    align: 'right',
                    label: 'Marge',
                    component: function (value) { return formatNumber(value.TotalMarge, '€'); },
                },
            ] }));
    };
    var renderSynthese = function () {
        if (loading) {
            return _jsx(Spinner, { height: 100 });
        }
        var Synthese = Array.isArray(datas) ? datas : [];
        var calculColor = function (nb) {
            if (nb < 50) {
                return 'error.main';
            }
            return nb > 75 ? 'success.main' : 'warning.main';
        };
        return (_jsx(Table, { color: "collaborateur", datas: Synthese, headers: [
                {
                    label: (_jsx(Typography, __assign({ startIcon: _jsx(SignatureIcon, {}) }, { children: "Synth\u00E8se" }))),
                    component: function (value) { return (_jsx(Link, { title: value.Libelle, color: "collaborateur", to: '/collaborateur/fiche/' + value.IdCollaborateur, icon: _jsx(CollaborateurIcon, {}) })); },
                },
                {
                    align: 'right',
                    label: 'Réalisé',
                    component: function (value) { return (_jsxs(_Fragment, { children: [formatNumber(value.TotalTarif, '€'), value.ObjectifTarif &&
                                renderInfo(formatNumber(value.ROTotalTarif, '%', 0), {
                                    right: true,
                                    color: calculColor(value.ObjectifTarif),
                                    tooltip: "Objectif : ".concat(formatNumber(value.ObjectifTarif, '€')),
                                })] })); },
                },
                {
                    align: 'right',
                    label: 'Marge',
                    component: function (value) { return (_jsxs(_Fragment, { children: [formatNumber(value.TotalMarge, '€'), value.ObjectifMarge &&
                                renderInfo(formatNumber(value.ROTotalMarge, '%', 0), {
                                    right: true,
                                    color: calculColor(value.ROTotalMarge),
                                    tooltip: "Objectif : ".concat(formatNumber(value.ObjectifMarge, '€')),
                                })] })); },
                },
                {
                    align: 'right',
                    label: 'En cours',
                    component: function (value) { return (_jsxs(_Fragment, { children: [formatNumber(value.TotalTarifEnCours, '€'), value.TotalMargeEnCours ? (renderInfo(formatNumber(value.TotalMargeEnCours, '€'), {
                                right: true,
                                color: 'secondary.main',
                                tooltip: "Marge : ".concat(formatNumber(value.TotalMargeEnCours, '€')),
                            })) : (_jsx(_Fragment, {}))] })); },
                },
                {
                    align: 'right',
                    label: 'Activités',
                    component: function (value) { return formatNumber(value.NbActivites); },
                },
            ] }));
    };
    var renderProchainesActivites = function () {
        if (loading) {
            return _jsx(Spinner, { height: 100 });
        }
        return (_jsx(_Fragment, { children: _jsx(Table, { title: "Prochaines activit\u00E9s", canEdit: true, canAdd: false, renderModalEdition: function (handleClose, _a) {
                    var _b = _a.ActiviteId, ActiviteId = _b === void 0 ? null : _b, _c = _a.ActiviteClientId, ActiviteClientId = _c === void 0 ? null : _c;
                    return (_jsx(EditionActivite, { ClientId: ActiviteClientId, ActiviteId: ActiviteId, handleClose: function () {
                            handleClose();
                            getData(false);
                        } }));
                }, datas: datas.Activites, headers: [
                    {
                        component: function (value, _a) {
                            var handleUpdate = _a.handleUpdate;
                            return (_jsxs(Stack, __assign({ spacing: 1 }, { children: [_jsx(Link, { title: value.Libelle, color: "activite", to: "/", onClick: function (e) {
                                            e.preventDefault();
                                            handleUpdate({
                                                ActiviteId: value.IdActivite,
                                                ActiviteClientId: value.ClientId,
                                            });
                                        }, icon: _jsx(ActiviteIcon, {}), bold: true }), _jsx(Link, { style: { fontSize: FONT_SIZE.SMALL }, title: value.Client, color: "client", to: '/client/fiche/' + value.ClientId })] })));
                        },
                    },
                    {
                        align: 'right',
                        minWidth: true,
                        component: function (value) { return (_jsx(_Fragment, { children: formatDateTime(value.DateDebut, false) })); },
                    },
                ] }) }));
    };
    var renderHitRatio = function () {
        if (loading) {
            return _jsx(Spinner, {});
        }
        var HitRatio = Array.isArray(datas) ? datas : [];
        return (_jsx(Table, { color: "affaire", datas: HitRatio, headers: [
                {
                    label: (_jsx(Typography, __assign({ startIcon: _jsx(SignatureIcon, {}) }, { children: "Cl\u00F4tur\u00E9es en" }))),
                    component: function (value) { return value.EtatLibelle; },
                },
                {
                    align: 'right',
                    label: 'Tarif',
                    component: function (value) { return formatNumber(value.TotalTarif, '€'); },
                },
                {
                    align: 'right',
                    label: 'Marge',
                    component: function (value) { return formatNumber(value.TotalMarge, '€'); },
                },
            ] }));
    };
    var renderPortefeuille = function () {
        if (loading) {
            return _jsx(Spinner, {});
        }
        var PortefeuilleByProbabilite = datas.Probabilites ? datas.Probabilites : [];
        var PortefeuilleByEtape = datas.Etapes ? datas.Etapes : [];
        var totaux = datas && datas.totaux ? datas.totaux : {};
        return (_jsxs(_Fragment, { children: [_jsx(Table, { color: "secondary", datas: PortefeuilleByEtape, headers: [
                        {
                            label: (_jsx(Typography, __assign({ startIcon: _jsx(SignatureIcon, {}) }, { children: "\u00C9tapes" }))),
                            assessor: 'Libelle',
                        },
                        {
                            align: 'right',
                            label: 'Tarif',
                            component: function (value) { return formatNumber(value.TotalTarif, '€'); },
                        },
                        {
                            align: 'right',
                            label: 'Marge',
                            component: function (value) { return formatNumber(value.TotalMarge, '€'); },
                        },
                    ], footerTotal: [
                        'Total',
                        formatNumber(totaux.TotalTarif, '€'),
                        formatNumber(totaux.TotalMarge, '€'),
                    ] }), _jsx(Table, { color: "secondary", datas: PortefeuilleByProbabilite, headers: [
                        {
                            label: (_jsx(Typography, __assign({ startIcon: _jsx(SignatureIcon, {}) }, { children: "Probabilit\u00E9s" }))),
                            assessor: 'Libelle',
                        },
                        {
                            align: 'right',
                            label: 'Tarif',
                            component: function (value) { return formatNumber(value.TotalTarif, '€'); },
                        },
                        {
                            align: 'right',
                            label: 'Marge',
                            component: function (value) { return formatNumber(value.TotalMarge, '€'); },
                        },
                    ] })] }));
    };
    var renderTotauxByTypeCatalogue = function () {
        if (loading) {
            return _jsx(Spinner, {});
        }
        var typesCatalogues = datas && datas.typesCatalogues ? datas.typesCatalogues : [];
        var totaux = datas && datas.totaux ? datas.totaux : {};
        return (_jsx(Table, { color: "affaire", datas: typesCatalogues, headers: [
                {
                    label: (_jsx(Typography, __assign({ startIcon: _jsx(SignatureIcon, {}) }, { children: "R\u00E9alis\u00E9" }))),
                    assessor: 'Libelle',
                },
                {
                    align: 'right',
                    label: 'Tarif',
                    component: function (value) { return formatNumber(value.TotalTarif, '€'); },
                },
                {
                    align: 'right',
                    label: 'Marge',
                    component: function (value) { return formatNumber(value.TotalMarge, '€'); },
                },
            ], footerTotal: [
                'Total',
                formatNumber(totaux.TotalTarif, '€'),
                formatNumber(totaux.TotalMarge, '€'),
            ] }));
    };
    var renderTotauxByCatalogue = function () {
        if (loading) {
            return _jsx(Spinner, {});
        }
        var Totaux = datas && datas.catalogues ? datas.catalogues : [];
        return (_jsx(Table, { color: "affaire", datas: Totaux, headers: [
                {
                    label: (_jsx(Typography, __assign({ startIcon: _jsx(SignatureIcon, {}) }, { children: "Gammes" }))),
                    assessor: 'Libelle',
                },
                {
                    align: 'right',
                    label: 'Nb. affaires',
                    component: function (value) { return formatNumber(value.NbAffaires, ''); },
                },
                {
                    align: 'right',
                    label: 'Tarif',
                    component: function (value) { return formatNumber(value.TotalTarif, '€'); },
                },
                {
                    align: 'right',
                    label: 'Marge',
                    component: function (value) { return formatNumber(value.TotalMarge, '€'); },
                },
            ] }));
    };
    var renderMixProduit = function () {
        if (loading) {
            return _jsx(Spinner, {});
        }
        var MixProduit = Array.isArray(datas) ? datas : [];
        return (_jsx(Table, { color: "affaire", datas: MixProduit, headers: __spreadArray([
                {
                    label: (_jsx(Typography, __assign({ startIcon: _jsx(SignatureIcon, {}) }, { children: "Produit / Service" }))),
                    assessor: 'Libelle',
                },
                {
                    align: 'right',
                    label: 'Nb. affaires',
                    component: function (value) { return formatNumber(value.NbAffaires, ''); },
                },
                {
                    align: 'right',
                    label: 'Tarif',
                    component: function (value) { return formatNumber(value.TotalTarif, '€'); },
                }
            ], (isMobile
                ? []
                : [
                    {
                        align: 'right',
                        label: '% de mes tarifs',
                        component: function (value) {
                            return formatNumber(value.PrcMixTotalTarif, '%');
                        },
                    },
                    {
                        align: 'right',
                        label: 'Marge',
                        component: function (value) { return formatNumber(value.TotalMarge, '€'); },
                    },
                    {
                        align: 'right',
                        label: '%  de mes marges',
                        component: function (value) {
                            return formatNumber(value.PrcMixTotalMarge, '%');
                        },
                    },
                ]), true) }));
    };
    var renderRecapitulatif = function () {
        if (loading) {
            return _jsx(Spinner, {});
        }
        var Recapitulatif = Array.isArray(datas) ? datas : [];
        return (_jsx(Table, { datas: Recapitulatif, headers: [
                {
                    minWidth: true,
                    label: (_jsx(Typography, __assign({ startIcon: _jsx(InfoIcon, {}) }, { children: "R\u00E9capitulatif" }))),
                    assessor: 'Donnee',
                },
                {
                    minWidth: true,
                    align: 'right',
                    component: function (value) { return formatNumber(value.Quantite, ''); },
                },
            ] }));
    };
    var renderActivites = function () {
        if (loading) {
            return _jsx(Spinner, {});
        }
        var Activites = Array.isArray(datas) ? datas : [];
        return (_jsx(Table, { color: "activite", datas: Activites, headers: [
                {
                    label: (_jsx(Typography, __assign({ startIcon: _jsx(ActiviteIcon, {}) }, { children: "Activit\u00E9s \u00E9ffectu\u00E9s" }))),
                    assessor: 'Type',
                },
                {
                    align: 'right',
                    component: function (value) { return formatNumber(value.NbActivites, ''); },
                },
            ] }));
    };
    var renderDerniersClients = function () {
        if (loading) {
            return _jsx(Spinner, { height: 100 });
        }
        var Clients = datas.Clients ? datas.Clients : [];
        return (_jsx(Table, { color: "client", title: "Nouveaux clients", datas: Clients, headers: [
                {
                    component: function (value) { return (_jsx(Link, { title: value.Libelle, color: "client", to: '/client/fiche/' + value.ClientId, icon: _jsx(ClientIcon, {}) })); },
                },
            ] }));
    };
    var renderCompteurs = function () {
        if (loading) {
            return _jsx(Spinner, { height: 200 });
        }
        var TotauxRealise = datas.Realise ? datas.Realise : null;
        var TotauxPortefeuille = datas.Portefeuille ? datas.Portefeuille : null;
        var TotauxCreation = datas.Creation ? datas.Creation : null;
        return (_jsxs(Stack, __assign({ spacing: 2 }, { children: [TotauxRealise && (_jsx(CircularProgressBar, { info: "Affaires valid\u00E9es", total: TotauxRealise.TotalTarif, percentage: TotauxRealise.ROTotalTarif * 100, withPercentage: TotauxRealise.TotalObjectifTarif > 0, icon: EuroIcon, defaultColor: "affaire" })), TotauxRealise && (_jsx(CircularProgressBar, { info: "Marges valid\u00E9es", total: TotauxRealise.TotalMarge, percentage: TotauxRealise.ROTotalMarge * 100, withPercentage: TotauxRealise.TotalObjectifMarge > 0, icon: MargeIcon, defaultColor: "affaire" })), TotauxPortefeuille && (_jsx(CircularProgressBar, { info: "Affaires en cours", total: TotauxPortefeuille.TotalTarif, percentage: TotauxPortefeuille.ROTotalTarif * 100, withPercentage: TotauxPortefeuille.TotalObjectifPortefeuille > 0, icon: PortfefeuilleIcon, defaultColor: "secondary" })), TotauxCreation && (_jsx(CircularProgressBar, { info: "Affaires cr\u00E9\u00E9es", total: TotauxCreation.TotalTarif, percentage: TotauxCreation.ROTotalTarif * 100, withPercentage: TotauxCreation.TotalObjectifCreation > 0, icon: CreationPortefeuilleIcon, defaultColor: "secondary" }))] })));
    };
    var renderTotaux = function () {
        if (loading) {
            return _jsx(Spinner, {});
        }
        var TotauxRealise = datas.Realise ? datas.Realise : null;
        var TotauxPortefeuille = datas.Portefeuille ? datas.Portefeuille : null;
        var TotauxCreation = datas.Creation ? datas.Creation : null;
        return (_jsx(Table, { color: "affaire", datas: TotauxRealise && TotauxPortefeuille && TotauxCreation
                ? [
                    {
                        Type: 'Tarif',
                        Objectif: TotauxRealise.TotalObjectifTarif,
                        Total: TotauxRealise.TotalTarif,
                        RO: TotauxRealise.ROTotalTarif * 100,
                    },
                    {
                        Type: 'Marge',
                        Objectif: TotauxRealise.TotalObjectifMarge,
                        Total: TotauxRealise.TotalMarge,
                        RO: TotauxRealise.ROTotalMarge * 100,
                    },
                ]
                : [], headers: [
                {
                    label: 'Bilan',
                    assessor: 'Type',
                },
                {
                    align: 'right',
                    label: 'Réalisé',
                    component: function (value) { return (_jsxs(_Fragment, { children: [formatNumber(value.Total, '€'), value.Objectif &&
                                renderInfo(formatNumber(value.RO, '%'), {
                                    right: true,
                                    tooltip: "Objectif : ".concat(formatNumber(value.Objectif, '€')),
                                })] })); },
                },
            ] }));
    };
    switch (Display) {
        case 'Forecast':
            return renderForecast();
        case 'Recapitulatif':
            return renderRecapitulatif();
        case 'Portefeuille':
            return renderPortefeuille();
        case 'HitRatio':
            return renderHitRatio();
        case 'TotauxByTypeCatalogue':
            return renderTotauxByTypeCatalogue();
        case 'TotauxByCatalogue':
            return renderTotauxByCatalogue();
        case 'MixProduit':
            return renderMixProduit();
        case 'TopAffaireEnCours':
            return renderTopAffaireEnCours();
        case 'TopAffaireGagnee':
            return renderTopAffaireGagnee();
        case 'TopClient':
            return renderTopClient();
        case 'DerniersClients':
            return renderDerniersClients();
        case 'Compteurs':
            return renderCompteurs();
        case 'Activites':
            return renderActivites();
        case 'ProchainesActivites':
            return renderProchainesActivites();
        case 'Synthese':
            return renderSynthese();
        default:
            return;
    }
};
//# sourceMappingURL=Statistique.js.map